import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  model,
  output,
  viewChild,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IconField } from "primeng/iconfield";
import { InputIcon } from "primeng/inputicon";
import { InputText } from "primeng/inputtext";

// The list search: fires on commit (change / Enter / the search button), not
// per keystroke. `page-search` sits on the host so page stylesheets that
// target `.page-filters > .page-search` keep matching.
@Component({
  selector: "app-search-box",
  templateUrl: "./search-box.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, IconField, InputIcon, InputText],
  host: { class: "page-search" },
})
export class SearchBoxComponent {
  public readonly value = model("");
  public readonly dataCy = input<string>();
  public readonly searchButtonDataCy = input<string>();

  public readonly searchSubmit = output<void>();

  private readonly searchInput =
    viewChild.required<ElementRef<HTMLInputElement>>("searchInput");

  // A programmatic reset fires no change event, so the search is emitted here.
  public clear(): void {
    this.value.set("");
    this.searchSubmit.emit();
    this.searchInput().nativeElement.focus();
  }
}
